import { Message } from "@copilotkit/runtime-client-gql";
import { createStore, StoreCore } from "@priolo/jon";
import chatApi from "api/copilot/chat";
import threadsApi from "api/copilot/threads";
import { ZeroGPTAgents } from "types/copilot/Agent";
import { Chat } from "types/copilot/Chat";



const setup = {

	state: {
		/** tutte le CHAT-THREADS */
		all: <Chat[]>[],
		currentThreadId: <string>null,
		currentAgent: <string>ZeroGPTAgents[0].code,
		/** sono i messaggi arrivati da copilotkit (non utilizzato) */
		messages: <Message[]>[],
		token: <string>null,
	},

	getters: {
		getChatById: (id: string, store?: ChatStore) => {
			return store.state.all.find(c => c.threadId === id);
		}
	},

	actions: {
		fetchToken: async (_: void, store?: ChatStore) => {
			// se è definito in env uso quello
			if ( import.meta.env.VITE_JWT_SECRET?.length > 0) {
				store.setToken(import.meta.env.VITE_JWT_SECRET)
				return
			}
			const res = await chatApi.fetchToken()
			store.setToken(res.token)
		},
		/**
		 * Carico tutti i THREADs a disposizione per l'AGENT selezionato
		 */
		updateTherads: async (_: void, store?: ChatStore) => {
			const res = await threadsApi.index(store.state.currentAgent)
			const threads = res?.threads ?? []

			let chats: Chat[] = []
			if (threads?.length > 0) {
				chats = threads.map<Chat>(t => {
					return {
						threadId: t.thread_id,
						title: t.first_message,
					}
				})

			} else {
				const threadId = crypto.randomUUID()
				chats = [{
					threadId: threadId,
					title: `id: ${threadId}`,
				}]
			}
			store.setAll(chats)
			store.setCurrentThreadId(chats[0].threadId)
		},

		createNewChat: (_: void, store?: ChatStore) => {
			const threadId = crypto.randomUUID()
			const chat = {
				threadId: threadId,
				title: `id: ${threadId}`,
			}
			store.setAll([...store.state.all, chat])
			store.setCurrentThreadId(chat.threadId)
		},

		setCurrent: (id: string, store?: ChatStore) => {
			const chat = store.getChatById(id)
			if (!chat) return
			store.setCurrentThreadId(chat.threadId)
		}
	},

	mutators: {
		setAll: (all: Chat[]) => ({ all }),
		setToken: (token: string) => ({ token }),
		setCurrentThreadId: (currentThreadId: string) => ({ currentThreadId }),
		setCurrentAgent: (currentAgent: string) => ({ currentAgent }),
	},
}

export type ChatState = typeof setup.state
export type ChatGetters = typeof setup.getters
export type ChatActions = typeof setup.actions
export type ChatMutators = typeof setup.mutators


export interface ChatStore extends StoreCore<ChatState>, ChatGetters, ChatActions, ChatMutators {
	state: ChatState
}

/**
 * Manage AGENTS AND THREADS
 */
const chatSo = createStore(setup) as ChatStore

export default chatSo
